<template>
  <v-layout column>
    <!-- <pre>results: {{ resultsPerPage }}</pre> -->
    <!-- <pre>per page: {{ totalPages }}</pre> -->
    <!-- <pre>{{ resultData }}</pre> -->
    <v-layout class="pa-2" justify-end>
      <v-flex class="pt-4 px-2 no-select">
        <v-layout justify-end>{{ $t('datatable-rows-per-page') }}</v-layout>
      </v-flex>
      <v-flex xs1>
        <v-select
          flat
          dense
          :items="resultsPerPageList"
          v-model="perPage"
          @change="$emit('per-page-changed', perPage)"
        />
      </v-flex>
      <v-flex xs2 class="pt-4 px-2 no-select">
        {{ resultData.from }} - {{ resultData.to }} {{ $t('datatable-of') }}
        {{ resultData.total }}
      </v-flex>
    </v-layout>
    <div class="text-xs-center">
      <v-pagination v-model="pagination.page" :length="totalPages || 1" total-visible="7" @input="paginating($event)" />
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'dt-pagination',

  props: {
    resultData: {
      required: true
    },
    pagination: {
      type: Object,
      required: true
    },
    perPageNumber: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      resultsPerPageList: [
        { text: 5, value: 5 },
        { text: 10, value: 10 },
        { text: 25, value: 25 },
        { text: 50, value: 50 }
      ],
      perPage: 10
    }
  },

  watch: {
    perPageNumber: {
      immediate: true,
      handler() {
        this.perPage = this.perPageNumber
      }
    }
  },

  computed: {
    totalPages() {
      if (this.resultData) {
        return Math.ceil(this.resultData.total / this.resultData.per_page)
      }
    }
  },

  methods: {
    paginating(event) {
      this.$emit('page-changed', event)
    }
  }
}
</script>

<style scoped></style>
